import dotenv from 'dotenv'
import React from 'react'
import I18n from 'redux-i18n'
import { Provider } from 'react-redux'
import { render } from 'react-dom'

import configureStore from './configureStore'
import { Application } from './components/Application'

import { default as en } from './translations/en.json'
import { default as de } from './translations/de.json'
import { default as es } from './translations/es.json'
import { default as nl } from './translations/nl.json'
import { default as fr } from './translations/fr.json'
import { default as ja } from './translations/ja.json'

const translationTexts = {
  en,
  de,
  es,
  nl,
  fr,
  ja,
  options: {
    'suppress_warnings': true,
  }
}

const languages = Object.keys(translationTexts)
  .filter((key) => key !== 'options')
  .map((key) => key.toLowerCase())

dotenv.config()
const store = configureStore()

render(
  <Provider store={store}>
    <I18n translations={translationTexts} initialLang='en' fallbackLang='en'>
      <Application languages={languages}/>
    </I18n>
  </Provider>,
  document.getElementById('root')
)
